import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { Category,Product } from 'src/app/app.models';
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {catchError, map} from "rxjs/operators";


@Injectable()
export class AddProductyService {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken()
        })
    }

    public url = "api/product";
    constructor(public http: HttpClient,
                public apiUrl: ApiUrl
                ) { }

    private handleObserverError(error: any): Observable<any>{
        console.log(error)
        return throwError(error.error || error)
    }

    getCategory(): Observable<any> {
        return this.http.get<any>(this.apiUrl.getCategory(), this.options).pipe(map((res) => res ? res : null ),catchError(this.handleObserverError));
    }

    addCategory(store:any): Observable<any>{
        return this.http.post<any>(this.apiUrl.getCategory(), JSON.stringify(store), this.options);
    }
    updateCategory(category:Category){
        return this.http.patch(this.url, category);
    }

    deleteCategory(id: number) {
        console.log(this.url)
        return this.http.delete(this.url + "/" + id, this.options);
    }

    addProduct(product:any): Observable<any>{
        return this.http.post<any>(this.apiUrl.getProducts(), JSON.stringify(product), this.options);
    }

    updateProduct(product:any): Observable<any>{
        return this.http.patch<any>(this.apiUrl.getProducts()+ product['id'] + "/", product, this.options);
    }
}
